module.exports = __webpack_public_path__ + "static/media/gloveProjections.c247daa5.png";